import apiClient, { setToken } from './config'

function saveUserInfo(response) {
  if (response && response.code === 200) {
    if (response.miToken) {
      setToken(response.miToken)
    }
    var user = {
      id: response.userEmail,
      email: response.userEmail,
      uName: response.userName,
      uPic: response.userPicUrl,
      lastLoginTime: response.lastLoginTime,
      credits: response.credits || 0,
      lastPay: response.lastPay || null
    }
    localStorage.setItem('userInfo', JSON.stringify(user))
    return { success: true, user: user }
  }
  return { success: false }
}

var authApi = {
  sendVerifyCode: function(email) {
    return apiClient.post('/sendVerifyCode', { email: email })
  },

  login: function(email, verifyCode) {
    return apiClient.post('/login', {
      email: email,
      verifyCode: verifyCode,
      type: 2
    }).then(function(response) {
      return saveUserInfo(response)
    })
  },

  googleLogin: function(email, uPic, uName) {
    return apiClient.post('/login', {
      email: email,
      uPic: uPic,
      uName: uName,
      type: 1
    }).then(function(response) {
      return saveUserInfo(response)
    })
  },

  logout: function() {
      var miToken = localStorage.getItem('token')
      if (!miToken) {
        return Promise.reject(new Error('No token'))
      }
     return apiClient.post('/logout', {
      miToken: miToken
    }).then(function() {
       setToken(null)
      localStorage.removeItem('userInfo')
    })
  },

  getCurrentUser: function() {
    var miToken = localStorage.getItem('token')
    if (!miToken) {
      return Promise.reject(new Error('No token'))
    }
    return apiClient.post('/getUserInfo', { miToken: miToken }).then(function(response) {
      if (response && response.code === 200) {
        return saveUserInfo(response)
      } else if (response && response.code === 502) {
        setToken(null)
        localStorage.removeItem('userInfo')
        return { success: false, expired: true }
      }
      return { success: false }
    })
  },

  updateProfile: function(userData) {
    return apiClient.put('/auth/profile', userData)
  },

  changePassword: function(passwords) {
    return apiClient.put('/auth/password', {
      current_password: passwords.currentPassword,
      new_password: passwords.newPassword
    })
  },

  requestPasswordReset: function(email) {
    return apiClient.post('/auth/password/reset', { email: email })
  },

  resetPassword: function(token, newPassword) {
    return apiClient.post('/auth/password/reset/confirm', {
      token: token,
      new_password: newPassword
    })
  },

  verifyEmail: function(token) {
    return apiClient.post('/auth/verify-email', { token: token })
  },

  resendVerification: function() {
    return apiClient.post('/auth/verify-email/resend')
  }
}

export function sendVerifyCode(email) {
  return authApi.sendVerifyCode(email)
}

export function login(email, code) {
  return authApi.login(email, code)
}

export function googleLogin(email, uPic, uName) {
  return authApi.googleLogin(email, uPic, uName)
}

export function logout() {
  return authApi.logout()
}

export function getCurrentUser() {
  return authApi.getCurrentUser()
}

export function updateProfile(userData) {
  return authApi.updateProfile(userData)
}

export function changePassword(passwords) {
  return authApi.changePassword(passwords)
}

export function requestPasswordReset(email) {
  return authApi.requestPasswordReset(email)
}

export function resetPassword(token, newPassword) {
  return authApi.resetPassword(token, newPassword)
}

export function verifyEmail(token) {
  return authApi.verifyEmail(token)
}

export function resendVerification() {
  return authApi.resendVerification()
}

export function isAuthenticated() {
  return !!localStorage.getItem('token')
}

export default authApi
